var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 25.104,
    viewBox: "0 0 24 25.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 24,
    height: 25.104,
    fill: "#2c5cde"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M23.969,8.211a.776.776,0,0,0-.8-.582H18.942a8.922,8.922,0,0,0,1.69-1.1,5.3,5.3,0,0,0,1.45-1.793,3.1,3.1,0,0,0,.154-2.452A3.528,3.528,0,0,0,21.2.815,3,3,0,0,0,18.258.131,4.956,4.956,0,0,0,16.7.919a11.758,11.758,0,0,0-2.314,2.3A28.046,28.046,0,0,0,12,6.8a27.4,27.4,0,0,0-2.488-3.7,12.476,12.476,0,0,0-1.853-1.9A5.333,5.333,0,0,0,5.691.117,2.965,2.965,0,0,0,3.723.229a3.573,3.573,0,0,0-1.409,1.1,3.034,3.034,0,0,0-.663,2.62A4.155,4.155,0,0,0,2.735,5.924a8.132,8.132,0,0,0,2.326,1.7H.855a.874.874,0,0,0-.531.151A.82.82,0,0,0,0,8.494q0,2.214,0,4.428v1.405c0,.019,0,.038,0,.057a.782.782,0,0,0,.828.8h.718v9.089c0,.028,0,.058,0,.089a.749.749,0,0,0,.369.63A.871.871,0,0,0,2.4,25.1H21.6a.886.886,0,0,0,.417-.077.774.774,0,0,0,.441-.736c0-2.486,0-5.014,0-7.458V15.183h.687A.789.789,0,0,0,24,14.326q0-1.867,0-3.734,0-1.054,0-2.108a1.046,1.046,0,0,0-.031-.273M13.325,7.56a25.545,25.545,0,0,1,2.43-3.6A9.9,9.9,0,0,1,17.535,2.2a3.27,3.27,0,0,1,1.3-.637,1.4,1.4,0,0,1,.159-.025l.051,0h.114a1.309,1.309,0,0,1,.8.246,2.29,2.29,0,0,1,.739.794,1.553,1.553,0,0,1,.006,1.5A3.551,3.551,0,0,1,19.824,5.2a8.437,8.437,0,0,1-2.979,1.653,13.577,13.577,0,0,1-2.967.651c-.183.02-.371.037-.553.053m2.452,1.605h6.688q0,2.241,0,4.482H15.777q0-2.241,0-4.482m5.151,9.159v5.245H15.777q0-4.193,0-8.386h5.151ZM3.522,4.465a2.213,2.213,0,0,1-.394-.947,1.428,1.428,0,0,1,.153-.892,2.242,2.242,0,0,1,.935-.942,1.247,1.247,0,0,1,.636-.152,2.3,2.3,0,0,1,1.173.377A7.2,7.2,0,0,1,7.669,3.3a23.693,23.693,0,0,1,3.007,4.263,14.62,14.62,0,0,1-3.113-.574A10.162,10.162,0,0,1,5.146,5.925a5.216,5.216,0,0,1-1.624-1.46m4.7,19.1H3.072q0-1.595,0-3.19v-5.2H8.224q0,4.193,0,8.386m0-14.4q0,2.241,0,4.482H1.536q0-2.241,0-4.482H8.224m6.018,14.381c0,.008,0,.015,0,.023H9.759q0-7.2,0-14.4h4.482q0,3,0,5.994Z",
    transform: "translate(0 0)",
    fill: "#2c5cde"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIc);
export default __webpack_public_path__ + "static/media/gift-ic.bb2238676bb93a576e6bb1df8b1210dd.svg";
export { ForwardRef as ReactComponent };